import React from 'react';

// Small line icons (24px grid, stroke = currentColor) for ThervuMitra's own UI.
const Icon = ({ children, className }) => (
  <svg
    className={`bm-icon ${className || ''}`}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const SearchIcon = props => (
  <Icon {...props}><circle cx="11" cy="11" r="6.5" /><path d="M16 16l4.5 4.5" /></Icon>
);

export const CheckBadgeIcon = props => (
  <Icon {...props}>
    <path className="bm-icon__fill" d="M12 2.5l2.3 1.7 2.8-.1.9 2.7 2.3 1.6-.9 2.7.9 2.7-2.3 1.6-.9 2.7-2.8-.1L12 21.5l-2.3-1.7-2.8.1-.9-2.7-2.3-1.6.9-2.7-.9-2.7 2.3-1.6.9-2.7 2.8.1z" />
    <path className="bm-icon__on-fill" d="M8.5 12.2l2.3 2.3 4.7-4.8" />
  </Icon>
);

export const CalendarIcon = props => (
  <Icon {...props}><rect x="3.5" y="5" width="17" height="15" rx="2.5" /><path d="M3.5 10h17M8 3v4M16 3v4" /></Icon>
);

export const ArrowIcon = props => (
  <Icon {...props}><path d="M5 12h14M13 6l6 6-6 6" /></Icon>
);

export const BookIcon = props => (
  <Icon {...props}><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5zM4 20.5A2.5 2.5 0 0 0 6.5 23H20v-5" /></Icon>
);

export const LanguageIcon = props => (
  <Icon {...props}><path d="M3 5h10M8 3v2M5.5 5c.8 3.6 3.6 6.4 7 7.5M10.5 5c-.8 3.6-3.6 6.4-7 7.5M12.5 21l4-10 4 10M14 17.5h5" /></Icon>
);

export const InstitutionIcon = props => (
  <Icon {...props}><path d="M3 9.5L12 4l9 5.5M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20.5h18" /></Icon>
);

export const ClockIcon = props => (
  <Icon {...props}><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></Icon>
);

export const AwardIcon = props => (
  <Icon {...props}><circle cx="12" cy="9" r="5.5" /><path d="M8.5 13.5L7 21l5-2.5 5 2.5-1.5-7.5" /></Icon>
);

export const PlayIcon = props => (
  <Icon {...props}><path className="bm-icon__fill" d="M9 7.5v9l7.5-4.5z" /></Icon>
);

export const UserIcon = props => (
  <Icon {...props}><circle cx="12" cy="8.5" r="4" /><path d="M4.5 20.5c1.2-3.6 4-5.5 7.5-5.5s6.3 1.9 7.5 5.5" /></Icon>
);

export const SettingsIcon = props => (
  <Icon {...props}><circle cx="12" cy="12" r="3" /><path d="M12 2.5v3M12 18.5v3M4.6 4.6l2.1 2.1M17.3 17.3l2.1 2.1M2.5 12h3M18.5 12h3M4.6 19.4l2.1-2.1M17.3 6.7l2.1-2.1" /></Icon>
);

export const MailIcon = props => (
  <Icon {...props}><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="M3.5 6.5L12 13l8.5-6.5" /></Icon>
);

export const SparkleIcon = props => (
  <Icon {...props}><path d="M10 3.5c.7 4 2.5 5.8 6.5 6.5-4 .7-5.8 2.5-6.5 6.5-.7-4-2.5-5.8-6.5-6.5 4-.7 5.8-2.5 6.5-6.5zM18 14.5c.3 1.8 1.2 2.7 3 3-1.8.3-2.7 1.2-3 3-.3-1.8-1.2-2.7-3-3 1.8-.3 2.7-1.2 3-3z" /></Icon>
);

export const ChatIcon = props => (
  <Icon {...props}><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4h0A2.5 2.5 0 0 1 4 13.5z" /><path d="M8.5 8.5h7M8.5 11.5h4.5" /></Icon>
);

export const RouteIcon = props => (
  <Icon {...props}><circle cx="6" cy="18" r="2.5" /><circle cx="18" cy="6" r="2.5" /><path d="M8.5 18H15a3 3 0 0 0 0-6H9a3 3 0 0 1 0-6h6.5" /></Icon>
);

export const ChartIcon = props => (
  <Icon {...props}><path d="M3.5 3.5v17h17" /><path d="M7.5 15l4-4.5 3 2.5 5-6" /></Icon>
);

export const CheckIcon = props => (
  <Icon {...props}><path d="M5 12.5l4.5 4.5L19 7.5" /></Icon>
);

export const LevelIcon = props => (
  <Icon {...props}><path d="M5 19.5v-4M10 19.5v-8M15 19.5v-11M20 19.5V4.5" /></Icon>
);

export const ListIcon = props => (
  <Icon {...props}><path d="M9 6.5h11M9 12h11M9 17.5h11" /><circle cx="4.5" cy="6.5" r="1" /><circle cx="4.5" cy="12" r="1" /><circle cx="4.5" cy="17.5" r="1" /></Icon>
);

export const HashIcon = props => (
  <Icon {...props}><path d="M9.5 3.5l-2 17M16.5 3.5l-2 17M4.5 9h16M3.5 15h16" /></Icon>
);

export const LinkIcon = props => (
  <Icon {...props}><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2" /><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2" /></Icon>
);

export const ChevronIcon = props => (
  <Icon {...props}><path d="M6 9.5l6 6 6-6" /></Icon>
);
